import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
  accent?: 'primary' | 'accent' | 'secondary';
}

export default function SectionHeader({
  title,
  subtitle,
  moreLink,
  moreText = '查看更多',
  accent = 'primary',
}: SectionHeaderProps) {
  const barColor =
    accent === 'accent'
      ? 'bg-accent-500'
      : accent === 'secondary'
        ? 'bg-secondary-500'
        : 'bg-primary-500';

  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className={`w-1.5 h-6 md:h-7 rounded-full ${barColor}`} />
        <div>
          <h2 className="text-lg md:text-2xl font-bold text-foreground-950 leading-tight">{title}</h2>
          {subtitle && <p className="mt-1 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreText}
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" />
        </Link>
      )}
    </div>
  );
}